import React, { useEffect, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { DASHBOARD_FILTERS } from "../../../constants/DashboardFilter";
import {
  clearTicketTaskFilters,
  setTicketTaskAllFilters,
} from "../../../store/reducers/TicketTaskFilter";
import { DisplayMsg } from "../../../services/toastService";
import { GetColor } from "../../../utils/array";
import { setUrl } from "../../../handlers";
import {
  setCurrentTab,
  setQuickSearch,
} from "../../../store/reducers/SharedLayoutDataSlice";

const Task = () => {
  const dispatch = useDispatch();
  const [assigneeCounts, setAssigneeCount] = useState([]);
  const [teamCounts, setTeamCount] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    LoadTask();
  }, []);

  const LoadTask = async () => {
    try {
      document.getElementById("loader").style.display = "block";
      const result = await fetch(setUrl("HOME", "LOADTASKDASHBOARD", true));
      const response = await result.json();
      if (response.status) {
        setAssigneeCount(response.AssigneeCounts);
        setTeamCount(response.TeamCount);
        StatusCountsGraph(response.StatusCounts);
        PriorityCountsGraph(response.PriorityCounts);
      }

      if (
        response?.status === false &&
        response?.Message ===
          "Collection was modified; enumeration operation may not execute."
      ) {
        LoadTask();
      }

      document.getElementById("loader").style.display = "none";
    } catch (e) {
      DisplayMsg("2", "Unable to Process the Request");
    }
  };

  const ShowTasksData = (type, value) => {
    dispatch(setQuickSearch(false));
    dispatch(setCurrentTab("tickets"));
    dispatch(clearTicketTaskFilters());
    if (type === "status") {
      dispatch(
        setTicketTaskAllFilters({
          status: value,
          type: "Task",
          overDue: value === "O" ? "Y" : "N",
          currentPage: 1,
        })
      );
    } else if (type === "priority") {
      dispatch(
        setTicketTaskAllFilters({
          priority: value,
          type: "Task",
          currentPage: 1,
        })
      );
    } else if (type === "assignee") {
      dispatch(
        setTicketTaskAllFilters({
          type: "Task",
          assignee: value.toUpperCase(),
          currentPage: 1,
          status: "FU",
        })
      );
    } else if (type === "teams") {
      dispatch(
        setTicketTaskAllFilters({
          type: "Task",
          team: value,
          status: "FU",
          currentPage: 1,
        })
      );
    }
    navigate("/tickets");
  };

  const StatusCountsGraph = (taskStatus) => {
    // var statusData = common.taskStatus;
    const statusData = taskStatus;
    document.getElementById("loader").style.display = "block";
    const statusarray = [];
    const updatedStatus = [];
    if (statusData.length === DASHBOARD_FILTERS.STATUS_ARRAY.length) {
      statusData.forEach((item) => {
        statusarray.push({ label: item.label, data: item.data });
      });
    } else {
      let commpleted = true;
      let pending = true;
      let pendingOnClient = true;
      let overdue = true;
      statusData.forEach((item) => {
        if (item.label.toUpperCase() === "COMPLETED") {
          commpleted = false;
        } else if (item.label.toUpperCase() === "PENDING ON CLIENT") {
          pendingOnClient = false;
        } else if (item.label.toUpperCase() === "PENDING") {
          pending = false;
        } else {
          overdue = false;
        }
        statusarray.push({ label: item.label, data: item.data });
      });
      if (commpleted) {
        statusData.push(DASHBOARD_FILTERS.TASK_COUNTS[0]);
        statusarray.push({
          label: DASHBOARD_FILTERS.TASK_COUNTS[0].label,
          data: DASHBOARD_FILTERS.TASK_COUNTS[0].data,
        });
      }
      if (pendingOnClient) {
        statusData.push(DASHBOARD_FILTERS.TASK_COUNTS[1]);
        statusarray.push({
          label: DASHBOARD_FILTERS.TASK_COUNTS[1].label,
          data: DASHBOARD_FILTERS.TASK_COUNTS[1].data,
        });
      }
      if (pending) {
        statusData.push(DASHBOARD_FILTERS.STATUS_ARRAY[2]);
        statusarray.push({
          label: DASHBOARD_FILTERS.TASK_COUNTS[2].label,
          data: DASHBOARD_FILTERS.TASK_COUNTS[2].data,
        });
      }
      if (overdue) {
        statusData.push(DASHBOARD_FILTERS.TASK_COUNTS[3]);
        statusarray.push({
          label: DASHBOARD_FILTERS.TASK_COUNTS[3].label,
          data: DASHBOARD_FILTERS.TASK_COUNTS[3].data,
        });
      }
    }

    am4core.useTheme(am4themes_animated);
    const Statusamchart = am4core.create("statusTask_Counts", "PieChart");

    const series = Statusamchart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "data";
    series.dataFields.category = "label";
    series.labels.template.disabled = true;
    series.ticks.template.disabled = true;

    series.alignLabels = true;
    const rgm = new am4core.RadialGradientModifier();
    rgm.brightnesses.push(0.3, 0.3, 0.3, 0.3, 0);
    series.slices.template.fillModifier = rgm;
    series.slices.template.strokeModifier = rgm;
    series.slices.template.strokeOpacity = 0.4;
    series.slices.template.strokeWidth = 0;

    Statusamchart.legend = new am4charts.Legend();
    series.slices.template.events.on("hit", (event) => {});
    Statusamchart.legend = new am4charts.Legend();

    // Position legend
    Statusamchart.legend.position = "left";
    Statusamchart.legend.fontSize = 14;
    Statusamchart.legend.labels.template.maxWidth = 145;
    Statusamchart.logo.disabled = true;
    Statusamchart.legend.valueLabels.template.position = "left";
    Statusamchart.legend.valueLabels.template.align = "left";
    Statusamchart.legend.labels.template.text =
      "[{color}] {data}   {category} ";
    Statusamchart.legend.valueLabels.template.text = "";
    Statusamchart.legend.itemContainers.template.togglable = false;
    Statusamchart.legend.itemContainers.template.events.on("hit", (ev) => {
      if (ev.target.dataItem.dataContext.category.toUpperCase() === "PENDING") {
        ShowTasksData("status", "P");
      } else if (
        ev.target.dataItem.dataContext.category.toUpperCase() === "COMPLETED"
      ) {
        ShowTasksData("status", "R");
      } else if (
        ev.target.dataItem.dataContext.category.toUpperCase() ===
        "PENDING ON CLIENT"
      ) {
        ShowTasksData("status", "Q");
      } else {
        ShowTasksData("status", "O");
      }
    });

    let label = "Pending";

    statusData.forEach((item) => {
      const data = statusData.find((item) => item.label === label);
      if (label === "Pending") {
        label = "Over Due";
      } else if (label === "Over Due") {
        label = "Pending On Client";
      } else if (label === "Pending On Client") {
        label = "Completed";
      }
      if (updatedStatus.length !== 4) {
        updatedStatus.push(data);
      }
    });

    Statusamchart.data = updatedStatus;
    series.colors.list = [
      am4core.color(GetColor(statusData[2].color)),
      am4core.color(GetColor(statusData[3].color)),
      am4core.color(GetColor(statusData[1].color)),
      am4core.color(GetColor(statusData[0].color)),
    ];
    document.getElementById("loader").style.display = "none";
  };
  const PriorityCountsGraph = (priorityData) => {
    // var priorityData = common.taskPriority;
    const taskPriority = [];
    let PriorityItems = [];

    priorityData.forEach((item, key) => {
      if (
        item.label === "Medium" ||
        item.label === "High" ||
        item.label === "Low" ||
        item.label === "Critical"
      ) {
        taskPriority.push(item);
      }
    });
    const priorityarray = [];
    if (taskPriority.length === DASHBOARD_FILTERS.PRIORITY_ARRAY.length) {
      taskPriority.forEach((item) => {
        priorityarray.push({ label: item.label, data: item.data });
      });
    } else {
      let medium = true;
      let low = true;
      let high = true;
      let citical = true;
      taskPriority.forEach((item) => {
        if (item.label.toUpperCase() === "MEDIUM") {
          medium = false;
        } else if (item.label.toUpperCase() === "LOW") {
          low = false;
        } else if (item.label.toUpperCase() === "HIGH") {
          high = false;
        } else {
          citical = false;
        }
        priorityarray.push({ label: item.label, data: item.data });
      });
      if (medium) {
        taskPriority.push(DASHBOARD_FILTERS.PRIORITY_ARRAY[0]);
        priorityarray.push({
          label: DASHBOARD_FILTERS.PRIORITY_ARRAY[0].label,
          data: DASHBOARD_FILTERS.PRIORITY_ARRAY[0].data,
        });
      }
      if (low) {
        taskPriority.push(DASHBOARD_FILTERS.PRIORITY_ARRAY[1]);
        priorityarray.push({
          label: DASHBOARD_FILTERS.PRIORITY_ARRAY[1].label,
          data: DASHBOARD_FILTERS.PRIORITY_ARRAY[1].data,
        });
      }
      if (high) {
        taskPriority.push(DASHBOARD_FILTERS.PRIORITY_ARRAY[2]);
        priorityarray.push({
          label: DASHBOARD_FILTERS.PRIORITY_ARRAY[2].label,
          data: DASHBOARD_FILTERS.PRIORITY_ARRAY[2].data,
        });
      }
      if (citical) {
        taskPriority.push(DASHBOARD_FILTERS.PRIORITY_ARRAY[3]);
        priorityarray.push({
          label: DASHBOARD_FILTERS.PRIORITY_ARRAY[3].label,
          data: DASHBOARD_FILTERS.PRIORITY_ARRAY[3].data,
        });
      }
    }

    am4core.useTheme(am4themes_animated);
    const Priorityamchart = am4core.create("priorityTask_Counts", "PieChart");

    const series = Priorityamchart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "data";
    series.dataFields.category = "label";
    series.labels.template.disabled = true;
    series.ticks.template.disabled = true;

    series.alignLabels = true;
    const rgm = new am4core.RadialGradientModifier();
    rgm.brightnesses.push(0.7, 0.7, 0.7, 0.7, 0.3);
    series.slices.template.fillModifier = rgm;
    series.slices.template.strokeModifier = rgm;
    series.slices.template.strokeOpacity = 0.4;
    series.slices.template.strokeWidth = 0;

    Priorityamchart.legend = new am4charts.Legend();
    series.slices.template.events.on("hit", (event) => {});
    Priorityamchart.legend = new am4charts.Legend();

    // Position legend
    Priorityamchart.legend.position = "left";
    Priorityamchart.legend.fontSize = 14;
    Priorityamchart.legend.labels.template.maxWidth = 145;
    Priorityamchart.logo.disabled = true;
    Priorityamchart.legend.valueLabels.template.position = "left";
    Priorityamchart.legend.valueLabels.template.align = "left";
    Priorityamchart.legend.labels.template.text =
      "[{color}] {data}   {category} ";
    Priorityamchart.legend.valueLabels.template.text = "";
    Priorityamchart.legend.itemContainers.template.togglable = false;
    Priorityamchart.legend.itemContainers.template.events.on("hit", (ev) => {
      if (
        ev.target.dataItem.dataContext.category.toUpperCase() === "CRITICAL"
      ) {
        ShowTasksData("priority", "Critical");
      } else if (
        ev.target.dataItem.dataContext.category.toUpperCase() === "HIGH"
      ) {
        ShowTasksData("priority", "High");
      } else if (
        ev.target.dataItem.dataContext.category.toUpperCase() === "MEDIUM"
      ) {
        ShowTasksData("priority", "Medium");
      } else {
        ShowTasksData("priority", "Low");
      }
    });

    let label = "Low";

    taskPriority.forEach((item) => {
      const data = taskPriority.find((item) => item.label === label);
      if (label === "Low") {
        label = "Medium";
      } else if (label === "Medium") {
        label = "High";
      } else if (label === "High") {
        label = "Critical";
      }
      PriorityItems.push(data);
    });

    PriorityItems = PriorityItems.reverse();
    Priorityamchart.data = PriorityItems;

    series.colors.list = [
      am4core.color(GetColor(taskPriority[3].color)),
      am4core.color(GetColor(taskPriority[1].color)),
      am4core.color(GetColor(taskPriority[0].color)),
      am4core.color(GetColor(taskPriority[2].color)),
    ];
  };
  const ShowAssignee = (name) => {
    ShowTasksData("assignee", name);
  };
  const ShowTeams = (value) => {
    ShowTasksData("teams", value);
  };

  const CheckCurrentUser = (username) => {
    const name = `${sessionStorage.firstName} ${sessionStorage.lastName}`;
    if (username === name) {
      return true;
    }
    return false;
  };

  const Assignlist = (arr) => {
    const myArray = [];
    arr.forEach((index) => {
      myArray.push(
        <li
          onClick={() => ShowAssignee(index.name)}
          className="py-1 w-50 ps-4 cursor-pointer"
          role="button"
          key={index.label}
        >
          <span
            className={`${
              CheckCurrentUser(index.name) === true
                ? "bg-green-800 border-0 text-white"
                : ""
            } listNumber text-sm`}
          >
            {index.data}
          </span>
          <span className="text-sm">{index.name.toUpperCase()}</span>
        </li>
      );
    });
    return myArray;
  };
  const TeamsList = (data) => {
    const teamArray = [];
    data.forEach((index) => {
      teamArray.push(
        <li
          className="py-1 w-50 ps-4 curor-pointer"
          onClick={() => ShowTeams(index.label)}
          key={index.label}
        >
          <span className="listNumber text-sm">{index.data}</span>
          <span className="text-sm" style={{ cursor: "pointer" }}>
            {index.name.toUpperCase()}
          </span>
        </li>
      );
    });
    return teamArray;
  };

  return (
    <>
      <div className="row table-panel-header mb-2 mt-3">
        <div className="col-md-12 col-sm-12">
          <h6>Task</h6>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <div className="table-panel">
            <div className="table-panel-header">
              <h6>Counts</h6>
            </div>
            <section id="statusTask_Counts" className="pieHeight" />
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="table-panel">
            <div className="table-panel-header">
              <h6>Priority</h6>
            </div>
            <section id="priorityTask_Counts" className="pieHeight" />
          </div>
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-md-6 col-sm-12">
          <div className="table-panel">
            <div className="table-panel-header">
              <h6>Assignees</h6>
            </div>
            <section className="assigneeBox py-2">
              <ul className="d-flex flex-wrap mb-0 list-unstyled">
                {assigneeCounts.length > 1 && Assignlist(assigneeCounts)}
              </ul>
            </section>
          </div>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="table-panel">
            <div className="table-panel-header">
              <h6>Teams</h6>
            </div>

            <section>
              <ul className="d-flex flex-wrap mb-0 list-unstyled">
                {teamCounts.length > 1 && TeamsList(teamCounts)}
              </ul>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default Task;
